// Centralized environment config for API targets.
// Use REACT_APP_API_BASE_URL and REACT_APP_SUBSCRIPTION_BASE_URL to override.

const getCurrentHostname = () => {
  if (typeof window === 'undefined' || !window.location) {
    return '';
  }

  return window.location.hostname || '';
};

const isLocalHostname = (hostname) => hostname === 'localhost' || hostname === '127.0.0.1';

const currentHostname = getCurrentHostname();
const isLocalhost = isLocalHostname(currentHostname);

const defaultApiBase = isLocalhost
  ? 'http://localhost:8080/api'
  : 'https://arrow-ai-cloud-run-123734116924.us-east1.run.app/api';

const defaultSubscriptionBase = isLocalhost
  ? 'http://localhost:3001'
  : 'https://arrow-ai-subscription-cloud-run-123734116924.us-east1.run.app';

const localhostUrlPattern = /^https?:\/\/(?:localhost|127\.0\.0\.1)(?::\d+)?(?:\/|$)/i;

const resolveBaseUrl = (rawValue, fallback) => {
  const cleanedValue = (rawValue || '').trim().replace(/\/+$/, '');

  if (!cleanedValue) {
    return fallback;
  }

  // CRA loads .env.local for production builds too, so guard against shipping localhost URLs.
  if (!isLocalhost && localhostUrlPattern.test(cleanedValue)) {
    return fallback;
  }

  return cleanedValue;
};

export const API_BASE_URL = resolveBaseUrl(process.env.REACT_APP_API_BASE_URL, defaultApiBase);
export const SUBSCRIPTION_BASE_URL = resolveBaseUrl(process.env.REACT_APP_SUBSCRIPTION_BASE_URL, defaultSubscriptionBase);
export const WORK_BASE_URL = resolveBaseUrl(process.env.REACT_APP_WORK_BASE_URL, isLocalhost
  ? 'http://localhost:8081/api/work/v1'
  : 'https://arrow-ai-work-123734116924.us-east1.run.app/api/work/v1');

const joinUrl = (base, path) => `${base}/${path.replace(/^\/+/, '')}`;

export const buildApiUrl = (path = '') => joinUrl(API_BASE_URL, path);
export const buildSubscriptionUrl = (path = '') => joinUrl(SUBSCRIPTION_BASE_URL, path);
export const buildWorkUrl = (path = '') => joinUrl(WORK_BASE_URL, path);
